"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = identityRepository;

var _immutable = _interopRequireDefault(require("immutable"));

var _Constants = require("FileManagerCore/Constants");

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var IdentityRepositoryDefaultState = _immutable.default.Map({
  inferredUserRole: _Constants.UserInferredRoles.get('HEAVY_MARKETER')
});

function identityRepository() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IdentityRepositoryDefaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      inferredUserRole = action.inferredUserRole;

  switch (type) {
    case _ActionTypes.INFERRED_USER_ROLE_FETCH_SUCCEEDED:
      return state.merge({
        inferredUserRole: inferredUserRole
      });

    default:
      return state;
  }
}

module.exports = exports.default;